import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import http from '@/$plugins/http'

import base from '../base'
import IS from '../base/is'
import CHANGE_REQUESTS from '../base/change-requests'
import ENTITY from '../base/entity'

export default {
  namespaced: true,
  state: base.createState(IS.state, CHANGE_REQUESTS.state, ENTITY.state, { /* define custom state-properties */ }),
  getters: base.createGetters(IS.getters, CHANGE_REQUESTS.getters, ENTITY.getters, { /* define custom getters */ }),
  mutations: base.createMutations(IS.mutations, CHANGE_REQUESTS.mutations, ENTITY.mutations, { /* define custom mutations */ }),
  actions: base.createEntityActions(
    STOREMODULE_ENDPOINTMODULE_MAP.customer,
    STOREMODULE_ENDPOINT_MAP.enduseraddresses,
    IS.actions,
    CHANGE_REQUESTS.actions,
    ENTITY.actions,
    {
      get (serverModuleName = '', serverEntityName = '', entityKey = '') {
        const isKey = `${serverEntityName}/get`

        return function ({ state, getters, commit, dispatch }, options = {}) {
          const o = base.getOptions(options, {
            page: state.statistics.page.number,
            pageSize: state.statistics.page.size
          })

          dispatch('getDefinition')
          commit('setLoading', { key: isKey, loading: true, initial: state.entities.length === 0 })

          return new Promise(resolve => {
            // Use custom endpoint: /customer/api/EndUserAddress/fromenduser/{relatedId1}/all
            // Use o.by.url.from which is /fromenduser/{id} and append /all
            // No query parameters
            const url = o.by && o.by.url && o.by.url.from
              ? `/${serverModuleName}/api/${serverEntityName}${o.by.url.from}/all`
              : `/${serverModuleName}/api/${serverEntityName}/all`

            http({
              method: 'get',
              url
              // Explicitly no params to prevent pagination query parameters
            })
              .then(response => {
                commit('setStatistics', response.data)
                commit('set', { key: entityKey, entities: response.data.result })
                resolve(getters.get)
              })
              .finally(() => {
                commit('setLoading', { key: isKey, loading: false })
              })
          })
        }
      },
      getAll (serverModuleName = '', serverEntityName = '', entityKey = '') {
        const isKey = `${serverEntityName}/getAll`

        return function ({ state, getters, commit, dispatch }, options = {}) {
          const o = base.getOptions(options)

          dispatch('getDefinition')
          commit('setLoading', { key: isKey, loading: true, initial: true })

          return new Promise(resolve => {
            // Use custom endpoint: /customer/api/EndUserAddress/fromenduser/{relatedId1}/all
            // Always use /all and no query parameters
            const url = o.by && o.by.id
              ? `/${serverModuleName}/api/${serverEntityName}/fromenduser/${o.by.id}/all`
              : `/${serverModuleName}/api/${serverEntityName}/all`

            http({
              method: 'get',
              url
              // Explicitly no params to prevent pagination query parameters
            })
              .then(response => {
                commit('set', { key: entityKey, entities: response.data.result })
                resolve(getters.get)
              })
              .finally(() => {
                commit('setLoading', { key: isKey, loading: false })
              })
          })
        }
      }
    }
  )
}

